import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Avatar from '@mui/material/Avatar';


export default function Citys() {
    return (
        <div >
            <GlobalStyles
                styles={{ ul: { margin: 0, padding: 0, listStyle: "none", }, display:'flex' }}
            />
         
            {/* Hero unit */}

         
            {/* End hero unit */}
            <Container maxWidth="mx" component="main">
                <Box
                    sx={{
                        display: 'flex',
                        '& > :not(style)': {
                            m: 1,
                            width: 128,
                            height: 128,
                        },
                        flexWrap:'wrap'

                    }}
                    sm={{
                        display: 'flex',
                        flexWrap:'wrap'
                    }}
                >
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                    <Paper variant="outlined" sx={{ display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: "space-around" }}>
                        <div variant="square">
                            <Box
                                component="img"
                                sx={{
                                    height: 60,
                                    width: 100,
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                }}
                                alt="The house from the offer."
                                src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                            />
                        </div>
                        <Typography>
                            hello
                        </Typography>
                    </Paper>
                </Box>
            </Container>
            {/* Footer */}

            {/* End footer */}
        </div>
    );
}
